var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{staticStyle:{"float":"right","margin-bottom":"10px"},attrs:{"current-page":_vm.currentPage,"pager-count":5,"page-sizes":[10, 15, 20, 25, 30],"page-size":_vm.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"current-change":_vm.handleCurrentChange,"size-change":_vm.handleSizeChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }